var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17856 17.5H13.2245C13.5063 17.5 13.7765 17.3881 13.9758 17.1888C14.1751 16.9895 14.287 16.7193 14.287 16.4375V5.28125C14.287 5.14035 14.231 5.00523 14.1314 4.9056C14.0318 4.80597 13.8966 4.75 13.7557 4.75H4.75C4.72344 4.75 4.67137 4.75425 4.62144 4.75744L3.17856 4.75C2.28712 4.75 1.5625 4.06894 1.5625 3.17856C1.5625 2.28712 2.26481 1.5625 3.15625 1.5625H15.375V13.7812C15.375 14.0745 15.5875 14.3125 15.8818 14.3125C16.1761 14.3125 16.4375 14.0745 16.4375 13.7812V1.03125C16.4375 0.738 16.1751 0.5 15.8818 0.5H3.17856C2.47541 0.500215 1.8006 0.777243 1.30013 1.27116C0.799654 1.76507 0.513745 2.43616 0.50425 3.13925L0.5 3.13394V14.8214C0.500141 15.5318 0.782391 16.213 1.28469 16.7153C1.78699 17.2176 2.46821 17.4999 3.17856 17.5Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.4bf5fd43e54fa92dc07a459a77340a06.svg";
export { ForwardRef as ReactComponent };